/* eslint-disable react-hooks/exhaustive-deps */
import { observer } from "mobx-react";
import React, { useEffect, memo, useState } from "react";
import { useStore } from "app/stores";
import { Card, Divider, Grid } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Add, CloudUpload, Delete, Edit, Folder } from "@material-ui/icons";
import {
  MULTIPLE_UPLOAD_IMAGES_TREATMENT,
  UPLOAD_MAXIMUM_IMAGES_TREATMENT_NUMBER,
} from "app/appConfig";
import { getDate } from "app/common/LocalFunction";
import LightGallary from "app/common/LightGallary";
import { ExpandMore } from "@material-ui/icons";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
const ImageListByDate = ({ patientId, isMobile }) => {
  const {
    folderSelectedView,
    handleUploadImageToFolder,
    handleDeleteByDate,
    handleDeletAllDate,
    handleDeletSingleImage,
    handleUploadImageByDate,
  } = useStore().patientManagementStore.imageGeneralTabStore;
  const [listGroup, setlistGroup] = useState({});

  const toggleListGroup = (index, boolean) => {
    setlistGroup((prevStatus) => ({
      ...prevStatus,
      [index]: boolean ? boolean : !prevStatus[index],
    }));
  };

  useEffect(() => {
    if (folderSelectedView?.fileDescriptionsByDate?.length > 0) {
      const newArr = folderSelectedView?.fileDescriptionsByDate?.reduce(
        (acc, _, index) => {
          acc[index] = true;
          return acc;
        },
        {}
      );

      setlistGroup(newArr);
    }
  }, [folderSelectedView]);

  return (
    <Card className="rounded-2xl shadow-sm border">
      <div className="p-4">
        <Grid container spacing={1} className="mb-3">
          <Grid item xs={12} md={6}>
            <div>
              <div className="font-semibold ">Quy định Upload</div>
              <span className="text-config">
                Giới hạn 1 lần gửi {UPLOAD_MAXIMUM_IMAGES_TREATMENT_NUMBER || 5}{" "}
                files, Định dạng hình: png, jpg, svg, jpeg
                {/* gif, heif, heic, webp Định dạng file docx, doc, xlsx, xls, pdf */}
              </span>
            </div>
          </Grid>
          {folderSelectedView && (
            <Grid item xs={12} md={6} className="justify-end flex gap-2">
              <input
                type="file"
                id={`image-by-folder`}
                accept="image/*"
                style={{ display: "none" }}
                multiple={MULTIPLE_UPLOAD_IMAGES_TREATMENT}
                onChange={async (event) => {
                  await handleUploadImageToFolder({
                    patientId,
                    id: folderSelectedView?.id,
                    files: Array.from(event?.target?.files),
                  });

                  const input = document.getElementById("image-by-folder");
                  if (input) input.value = "";
                }}
              />
              <Button
                variant="outlined"
                startIcon={
                  <CloudUpload
                    size={16}
                    style={{
                      color: "#4276a4",
                    }}
                  />
                }
                onClick={() => {
                  document.getElementById(`image-by-folder`)?.click();
                }}
                className="action-btn-custom"
              >
                Tải tệp lên
              </Button>
              {folderSelectedView?.fileDescriptionsByDate?.length > 0 && (
                <Button
                  variant="outlined"
                  startIcon={
                    <Delete
                      size={16}
                      style={{
                        color: "#f16321",
                      }}
                    />
                  }
                  onClick={handleDeletAllDate}
                  className="action-btn-custom"
                >
                  Xóa tất cả
                </Button>
              )}
            </Grid>
          )}
        </Grid>

        <Divider className="my-3" />
        {folderSelectedView?.fileDescriptionsByDate?.map(
          (datePatient, index) => {
            return (
              <>
                <div className="flex justify-between mb-3 mt-2">
                  <span
                    className="font-semibold text-gray-700  flex align-center gap-2 pointer"
                    onClick={() => toggleListGroup(index)}
                  >
                    {listGroup[index] ? <ExpandMore /> : <ExpandLessIcon />}
                    {getDate(datePatient?.date)}
                  </span>

                  <span>
                    <Button
                      variant="outlined"
                      startIcon={
                        <Delete
                          size={16}
                          style={{
                            color: "#f16321",
                          }}
                        />
                      }
                      onClick={() => {
                        handleDeleteByDate(datePatient?.date);
                      }}
                      className="action-btn-custom flex items-center"
                    >
                      {!isMobile && "Xóa"}
                    </Button>
                  </span>
                </div>

                {/* Image Grid */}
                <Grid
                  container
                  spacing={1}
                  className="list-image-by-date"
                  style={{ position: "relative" }}
                >
                  {/* Layer chứa LightGallery */}
                  <ViewListImage
                    datePatient={datePatient}
                    handleDeletSingleImage={handleDeletSingleImage}
                  />

                  <Grid item xs={6} md={2} style={{ position: "relative" }}>
                    <div
                      className="upload-add-box"
                      onClick={() => {
                        document
                          .getElementById(`image-by-date-${index}`)
                          ?.click();
                      }}
                    >
                      <Add style={{ fontSize: 40, color: "#999" }} />
                      <span>Thêm ảnh</span>
                    </div>
                  </Grid>
                  <input
                    type="file"
                    id={`image-by-date-${index}`}
                    accept="image/*"
                    style={{ display: "none" }}
                    multiple={MULTIPLE_UPLOAD_IMAGES_TREATMENT}
                    onChange={async (event) => {
                      await handleUploadImageByDate({
                        patientId,
                        id: folderSelectedView?.id,
                        files: Array.from(event?.target?.files),
                        updateCreateDate: datePatient?.date,
                      });

                      const input = document.getElementById(
                        `image-by-date-${index}`
                      );
                      if (input) input.value = "";
                    }}
                  />
                </Grid>
              </>
            );
          }
        )}
      </div>
    </Card>
  );
};

const ViewListImage = observer(({ handleDeletSingleImage, datePatient }) => {
  return (
    <>
      <LightGallary>
        {datePatient?.images?.map((item, id) => (
          <Grid
            key={item.id}
            component={"a"}
            md={2}
            xs={6}
            className="lightgallery-item"
            data-src={item?.url}
            data-sub-html={item?.name || ""}
            href={item?.url}
            style={{
              // width: "100%",
              aspectRatio: "1 / 1",
              overflow: "hidden",
              borderRadius: 6,
              cursor: "pointer",
              position: "relative",
            }}
          >
            <img
              src={item.url}
              alt={item.name}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: 6,
              }}
            />
          </Grid>
        ))}
      </LightGallary>
      <Grid item xs={12} md={12}>
        <div className="overlay-delete-layer">
          <Grid container spacing={1} className="list-image-by-date">
            {datePatient?.images?.map((item, id) => (
              <Grid
                key={item?.id}
                md={2}
                xs={6}
                item
                style={{
                  position: "relative",
                  aspectRatio: "1 / 1",
                }}
              >
                <div
                  className="delete-btn-image"
                  onClick={() =>
                    handleDeletSingleImage({
                      date: datePatient?.date,
                      idImage: item?.id,
                    })
                  }
                >
                  <Delete fontSize="small" />
                </div>
              </Grid>
            ))}
          </Grid>
        </div>
      </Grid>
    </>
  );
});

export default memo(observer(ImageListByDate));
